export const mockedBrands = {
    brands: [
        { id: "1", name: "Nike" },
        { id: "2", name: "Adidas" },
        { id: "3", name: "Apple" },
        { id: "4", name: "Samsung" },
        { id: "5", name: "Microsoft" },
        { id: "6", name: "Google" },
        { id: "7", name: "Amazon" },
        { id: "8", name: "Tesla" },
        { id: "9", name: "Coca-Cola" },
        { id: "10", name: "McDonald's" },
        { id: "11", name: "Starbucks" },
        { id: "12", name: "Disney" },
        { id: "13", name: "Toyota" },
        { id: "14", name: "Sony" },
        { id: "15", name: "Intel" },
        { id: "16", name: "IBM" },
        { id: "17", name: "Oracle" },
        { id: "18", name: "Facebook" },
        { id: "19", name: "Twitter" },
        { id: "20", name: "LinkedIn" },
    ],
};
